export default "__VITE_ASSET__DhNtF9ub__"